module.exports = __webpack_public_path__ + "img/ch54.9ba5059e.jpg";